<script>
import DigitImageDisplay from "@homepage/components/DigitImageDisplay.vue";

export default {
	name: "Card",
	components: {DigitImageDisplay},
	props: {
		result: {
			type: Object,
			required: true
		},
		displayAsOne: {
			type: Boolean,
			default: true
		},
		pickTwoImage: {
			type: Object,
			default: null
		},
		pickThreeImage: {
			type: Object,
			default: null
		},
		pickFourImage: {
			type: Object,
			default: null
		},
		pickFiveImage: {
			type: Object,
			default: null
		},
		imageDimensions: {
			type: Object,
			default: () => ({
				height: 37,
				width: 37
			})
		}
	}
}
</script>

<template>
	<v-card>
		<v-container>
			<slot name="header"></slot>
			<v-row class="flex-column" justify="center" align="center">
				<v-col cols="auto" class="text-center">
					<slot name="sortition-area" :date="result.date" :sortition="result.sortition">
						<h2>{{ result.sortition.name }}</h2>
						<h5 class="mb-0">
							{{ result.date }}
						</h5>
					</slot>
				</v-col>
				<v-col cols="auto">
					<slot v-if='result.first || result.second || result.third'
								name="first-second-third"
								v-bind="$props">
						<v-row justify='center' no-gutters>
							<v-col cols='auto' class='d-flex align-center'>
								<h4 class="mx-1">
									1st
								</h4>
								<digit-image-display :display-as-one="displayAsOne" class='d-flex' :digit='result.first'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
							<v-col cols='auto' class='d-flex mx-1 align-center'>
								<h4 class="mx-1">
									2nd
								</h4>
								<digit-image-display :display-as-one="displayAsOne" class='d-flex' :digit='result.second'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
							<v-col cols='auto' class='mx-1 d-flex align-center'>
								<h4 class="mx-1">
									3rd
								</h4>
								<digit-image-display :display-as-one="displayAsOne" class='d-flex' :digit='result.third'
																		 :image-dimensions='imageDimensions'/>
							</v-col>
						</v-row>
					</slot>
					<v-row v-if='result.pickTwo' no-gutters>
						<v-col cols='12' md="auto" class="d-flex align-center">
							<v-img v-if='pickTwoImage' v-bind="pickTwoImage"></v-img>
							<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 2</span>
							<digit-image-display class='d-flex ml-3' :digit='result.pickTwo' :image-dimensions='imageDimensions'/>
						</v-col>
					</v-row>
					<v-row v-if='result.cashThree' no-gutters>
						<v-col cols='12' md="auto" class="d-flex align-center">
							<v-img v-if='pickThreeImage' v-bind="pickThreeImage"></v-img>
							<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 3</span>
							<digit-image-display class='d-flex ml-3' :digit='result.cashThree' :image-dimensions='imageDimensions'/>
						</v-col>
					</v-row>
					<v-row v-if='result.pickFour' no-gutters>
						<v-col cols='12' md="auto" class="d-flex align-center">
							<v-img v-if='pickFourImage' v-bind="pickFourImage"></v-img>
							<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 4</span>
							<digit-image-display class='d-flex ml-3' horizontal :digit='result.pickFour' :image-dimensions='imageDimensions'/>
						</v-col>
					</v-row>
					<v-row v-if='result.pickFive' no-gutters>
						<v-col cols='12' md="auto" class="d-flex align-center">
							<v-img v-if='pickFiveImage' v-bind="pickFiveImage"></v-img>
							<span v-else class='font-weight-bold text-uppercase text-h6'>PICK 5</span>
							<digit-image-display class='d-flex ml-3' horizontal :digit='result.pickFive' :image-dimensions='imageDimensions'/>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>

<style scoped lang="scss">

</style>
